export default function PathwayController() {

}